/**
 * Issue #224 — 审计日志查询 API 客户端（ADMIN+，org 隔离由后端强制）。
 *   GET /admin/audit-logs           -> AuditLogListResult（分页 + 高级搜索）
 *   GET /admin/audit-logs/columns   -> 列白名单 + 事件类型下拉
 */
import { apiClient } from './api';
import type {
  AuditLogColumnsResponse,
  AuditLogListResult,
} from './types';

export function listAuditLogsApi(
  query: Record<string, unknown> = {},
): Promise<AuditLogListResult> {
  return apiClient.get<AuditLogListResult>('/admin/audit-logs', query);
}

export function listAuditLogColumnsApi(): Promise<AuditLogColumnsResponse> {
  return apiClient.get<AuditLogColumnsResponse>('/admin/audit-logs/columns');
}
